<template>
  <div class="backgroud-white cs-courseSchedule-editor" v-loading="isLoading">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-form ref="model" :rules="rules" :model="model" label-width="200px">     
        <el-form-item label="免计签到" prop="skipSignIn"  size="mini">
          <el-checkbox @change="checkAllInputs" v-model="model.skipSignIn" class="input-width"></el-checkbox>
        </el-form-item>
        <el-form-item label="课程类型" prop="courseCategory">
          <el-select
            class="input-width"
            @change="checkAllInputs"
            v-model="model.courseCategory"
            placeholder="请选择课程类型"
          >
            <el-option
              v-for="item in courseCategoryList"
              :key="item.Key"
              :label="item.Value"
              :value="item.Key"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col :span="18" class="footer-left">
          <span v-if="!showError"></span>
          <el-alert
            :closable="false"
            v-if="showError"
            v-bind:title="errorMessage"
            type="error"
            show-icon
          ></el-alert>
        </el-col>
        <el-col class="footer-right" :span="6">
          <el-button
            :disabled="submitBtnDisable"
            :type="submitBtnClass"
            @click="save()"
          >激活课程</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
body .popup-content-area-small{
  padding-top: 30px;
  padding-bottom: 20px;
  min-height: 100px;
}
</style>

<script>
import { activateCourse } from "../../service/teacherCourse.service.js";
import { getCourseCategoryList } from "../../service/common.service.js";
import { srcTimesOfDay } from "../../service/api-base.service";
let moment = require("moment");

export default {
  props: {
    data: {
      courseType: Number,
      universityName: String,
      courseName: String,
      teacherId: Number,
      courseId: Number,
      campusId: Number,
      courseCategory: Number
    }
  },
  data() {
    let _self = this;
    let startTimeValidator = (rule, value, callback) => {
      if (value === "") {
        return callback(new Error("请选择开始时间"));
      } else {
        return callback();
      }
    };

    return {
      model: {
        skipSignIn: false,
        courseCategory: 1,
      },
      allCourseCategoryList: [],
      courseCategoryList: [],
      startTimeDisabled: true,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      showError: false,
      errorMessage: "",
      isLoading: false,
      rules:{}
    };
  },
  components: {},
  created() {
    getCourseCategoryList(1).then(result =>{
      if (!!result && result.success){
        this.allCourseCategoryList = result.data;
        //let list = result.data;
        //list.splice(list.findIndex(item => item.Key == 2), 1)
        //this.courseCategoryList = list;
        this.init();
      }
    });
  },
  methods: {
    checkAllInputs() {
      let isValid = true;
      this.$refs.model.validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      if (isValid) {
        //this.submitBtnClass = "primary";
        //this.submitBtnDisable = false;
      } else {
        //this.submitBtnClass = "info";
        //this.submitBtnDisable = true;
      }
    },
    save() {
      if (!!this.$refs["model"]) {
        let isValid = true;
        this.$refs["model"].validate(valid => {
          if (valid) {
          } else {
            isValid = false;
          }
        });
        if (!isValid) {
          return false;
        }
        let msg = "您确定要激活 " + this.data.courseName + " 这门课吗(非线上课程)？激活后，2小时内无法撤销，请谨慎操作！！"

        this.$confirm(msg, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.submitBtnDisable = true;
            this.isLoading = true;

            activateCourse(
              this.data.teacherId,
              this.data.courseId,
              this.data.campusId,
              !this.model.skipSignIn,
              this.model.courseCategory
            )
              .then(result => {
                if (result && result.success) {
                  let msg = "课程" + this.data.courseName + "已激活成功！";
                  if (!!result.data.Message) {
                    msg += result.data.Message;
                  }
                  this.$message(msg);
                  this.$emit("success", result.data);
                } else {
                  this.errorMessage = result.message;
                  this.showError = true;
                }
                this.isLoading = false;
                this.submitBtnDisable = false;
              })
              .catch(() => {
                this.isLoading = false;
                this.submitBtnDisable = false;
              });
          })
          .catch(() => {
            this.proccessing = false;
          });
      }
    },
    close() {
      this.$emit("closeDialog");
    },
    init(){
      this.model.skipSignIn = false;
      let courseCategory = 1;
      if (this.data && this.data.courseCategory){
        courseCategory = this.data.courseCategory;
      }else{
        this.courseCategoryList = this.allCourseCategoryList.filter(i => i.Key === 3 || i.Key === 4 || i.Key === 5
          || i.Key === 1
        );
      }
      //3 期中复习, 4 期末复习, 5 期末复习公开课, 当前课程所属类型
      this.courseCategoryList = this.allCourseCategoryList.filter(i => i.Key === 3 || i.Key === 4 || i.Key === 5
          || i.Key === courseCategory
        );
      this.model.courseCategory = courseCategory;
    }
  },
  watch: {
    data: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/signInManage/courseActiveNormal.vue